import {
    CloseCircleOutlined, ReloadOutlined
} from "@ant-design/icons";
import {
    Button,
    Col,
    Form, Input,
    Row,
    Select
} from "antd";
import { useEffect, useRef, useState } from "react";
import { ROOT_URL } from "../../constants/api";
import { nofication } from '../../commons/Nofication';
import Upload from '../../commons/Upload';
import MainLayout from "../../components/mainLayout";
import { authApis } from "../../services/authApi";
import "./index.scss";

const Register = () => {
    const [fileList, setFileList] = useState();
    const [imageUrl, setImageUrl] = useState();
    const [form] = Form.useForm();

    const onFinish = async () => {
        const values = form.getFieldValue();
        values.logo = undefined;
        const formData = new FormData();
        for (var key in values) {
            formData.append(key, values[key]);
        }

        formData.append('logo', fileList)
        const res = await authApis
            .addSetting(formData)
            .then((data) => {
                if (data.status_code === 200) {
                    nofication('success', 'Thành công', 'Cập nhật thành công!');
                } else {
                    nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại thông tin !');
                }
            })
            .catch((errors) => {
                nofication('error', 'Thất bại', 'Không kết nối được server');
                console.log(errors)
            });
        return res;
    };

    useEffect(() => {
        authApis.getSetting()
        .then((data)=>{
            form.setFieldsValue( data.data )
            setImageUrl(data.data.logo ? ROOT_URL + data.data.logo : '')
        })
        .catch((errors) => {
            nofication('error', 'Thất bại', 'Lấy dữ liệu thất bại');
        });
    },[])

    return (
        <MainLayout
            isShowActionHeader={false}
            title="Translate"
            link="/translate/"
        >
            <Row gutter={16} style={{ minHeight: "873px" }}>
                <Col span={24}>
                    <div className="box-class" >
                        <Form
                            form={form}
                            layout="vertical"
                            colon={true}
                            onFinish={onFinish}
                        >
                            <Form.Item
                                label="Select language"
                                name={"language"}
                                colon={true}
                            >
                                <Select placeholder={"language"}>
                                    <Select.Option value={"0"}>
                                        Tiếng việt
                                    </Select.Option>
                                    <Select.Option value={"1"}>
                                        Tiếng anh
                                    </Select.Option>
                                    <Select.Option value={"2"}>
                                        Tiếng hàn
                                    </Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item>
                                <Row
                                    justify="space-between"
                                    style={{ marginTop: 30 }}
                                >
                                    <Col>
                                        <Button
                                            type="primary"
                                            icon={<ReloadOutlined />}
                                            htmlType="submit"
                                        >
                                            Submit
                                        </Button>
                                        <Button
                                            style={{
                                                background: "#6c757d",
                                                color: "white",
                                                marginLeft: 20,
                                            }}
                                            htmlType="reset"
                                        >
                                            Reset
                                        </Button>
                                    </Col>
                                    <Col>
                                        <Button
                                            style={{
                                                background: "#c92f2f",
                                                color: "white",
                                            }}
                                            icon={<CloseCircleOutlined />}
                                        >
                                            Cancel
                                        </Button>
                                    </Col>
                                </Row>
                            </Form.Item>
                        </Form>
                    </div>
                </Col>
            </Row>
        </MainLayout>
    );
};

export default Register;
